import styled, { css } from 'styled-components'

export const SectionInfoPagamento = styled.section`
  border-bottom: 0.0625rem solid #e8e8e8;
  height: 5.125rem;
  display: flex;
  align-items: center;
  ul {
    margin-bottom: 0rem;
    display: flex;
    align-items: center;
    justify-content: space-between;
    li {
      display: flex;
      align-items: center;
      img {
        margin-right: 0.8125rem;
      }
      p {
        margin-bottom: 0rem;
        font-size: 1rem;
        line-height: 1.1875rem;
        color: #363843;
        strong {
          font-weight: 600;
          font-size: 1rem;
          line-height: 1.1875rem;
          color: #363843;
        }
      }
    }
  }
  @media (max-width: 30rem) {
    height: auto;
    padding: 2.5rem 0rem;
    ul {
      flex-direction: column;
      align-items: flex-start;
      max-width: 18.125rem;
      margin-bottom: 0.5rem;
      li {
        margin-bottom: 2.3125rem;
        &:last-child {
          margin-bottom: 0rem;
        }
        &:nth-child(2) {
          p {
            strong {
              display: block;
            }
          }
        }
        p {
          flex: 1;
          font-size: 0.875rem;
          strong {
            font-size: 0.875rem;
          }
        }
      }
    }
  }
`

export type FooterSectionProps = {
  darkTheme?: boolean
}

export const FooterSection = styled.footer<FooterSectionProps>`
  padding-bottom: 1.8125rem;

  ${({ darkTheme }) =>
    darkTheme &&
    css`
      background-color: #141723 !important;

      span,
      a,
      strong,
      h1,
      h2,
      h3,
      h4,
      button,
      p {
        color: #fff !important;
      }
    `}

  .area-primaria {
    display: flex;
    justify-content: space-evenly;
    align-items: center;
    padding-top: 3.125rem;
    flex-wrap: wrap;
    .itemInstitucional {
      margin: 0 1em 0 2em;
    }
    .itemDuvidas {
      margin: 0 1em 0 2em;
    }
    .itemDuvidasMenu {
      margin: 0 0 0 2em;
    }
    .esq {
      .atendimento {
        display: flex;
        flex-wrap: wrap;
        justify-content: space-evenly;
        align-items: center;
        margin: 0 0 3em 0;
        img {
          margin-right: 1.0625rem;
        }
        .info {
          max-width: 18.75rem;
          span {
            display: block;
            font-size: 0.875rem;
            line-height: 1.25rem;
            color: #646981;
          }
          a {
            font-weight: bold;
            font-size: 2.0625rem;
            line-height: 2.5rem;
            color: #363843;
          }
        }
      }
      .facebook {
        border-radius: 0.5rem;
        overflow: hidden;
      }
    }
    nav {
      display: flex;
      align-items: flex-start;
      .item {
        &:first-child {
          margin-left: 0rem;
        }
        &:last-child {
          margin-bottom: 2.5rem;
        }
        h3 {
          font-weight: bold;
          font-size: 1.5rem;
          line-height: 1.625rem;
          color: #363843;
          margin-bottom: 1.5625rem;
        }
        ul {
          li {
            margin-bottom: 1.375rem;
            &:last-child {
              margin-bottom: 0rem;
            }
            a {
              font-size: 0.875rem;
              color: #646981;
            }
          }
        }
      }
    }
  }
  .area-secundaria {
    border-top: 0.0625rem solid #e8e8e8;
    padding-top: 1.8125rem;
    margin-top: 1em;
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: space-evenly;
    flex: auto;
    flex-direction: row;
    .texto-rodape {
      text-align: center;
    }
    .cont-geral {
      display: flex;
      align-items: center;

      @media (min-width: 75rem) {
        width: 75rem;
      }
    }
    .esq {
      display: flex;
      align-items: center;
      justify-content: center;
      flex: 1;
      margin-right: 0;
      flex-wrap: wrap;
      .item {
        ul {
          margin-bottom: 0rem;
        }
        &:first-child {
          margin-left: 0rem;
        }
        &:nth-child(2) {
          .selos {
            flex-wrap: wrap;
            margin: 0 0 1em 4rem;
            gap: 3rem;
          }
        }
        span {
          display: block;
          margin-bottom: 1rem;
          font-size: 0.875rem;
          line-height: 1.25rem;
          color: #646981;
        }
        ul {
          display: flex;
          align-items: center;
          justify-content: center;
          li {
            margin-left: 1.125rem;
            &:first-child {
              margin-left: 0rem;
            }
            #tl_popupSC5tLDD {
              width: 100%;
              height: 100%;
            }
            iframe {
              height: 4.375rem;
              width: 11.375rem;
              margin-top: -0.3125rem;
              overflow: hidden;
            }
          }
        }
      }
      .formasDePagamento {
        display: block;
        align-items: center;
        margin: 0 0 2em 0em;
        ul {
          width: 100%;
          margin-bottom: 0.5rem;
          display: flex;
          justify-content: center;
          align-items: center;
          flex-wrap: wrap;
          gap: 0.625rem;

          li {
            padding: 0;
            margin: 0;
          }
        }
      }
    }
    .avaliacaoConsumidor {
      display: flex;
      align-items: center;
    }
    .dev {
      display: flex;
      align-items: center;
      ul {
        display: flex;
        align-items: center;
      }
    }
    p {
      max-width: 75rem;
      margin: 0 auto;
      color: #a0a4b3;
      font-size: 0.8125rem;
      line-height: 1.25rem;
    }
  }
  .area-compra {
    border-top: 0.0625rem solid #e8e8e8;
    padding-top: 1.8125rem;
    .cont-geral {
      margin-bottom: 0;
      display: flex;
      align-items: center;
      justify-content: center;
    }
    .esq {
      display: flex;
      align-items: flex-start;
      .item {
        margin-left: 7.5rem;
        &:first-child {
          margin-left: 0rem;
        }
        span {
          display: block;
          margin-bottom: 1rem;
          font-size: 0.875rem;
          line-height: 1.25rem;
          color: #646981;
        }
        ul {
          display: flex;
          align-items: center;
          li {
            margin-left: 1.125rem;
            &:first-child {
              margin-left: 0rem;
            }
          }
        }
        .telefone-contato {
          display: flex;
          justify-content: center;
          align-items: center;
          img {
            margin-right: 0.625rem;
          }
          .telefone {
            .topo {
              h2 {
                font: normal 600 0.875rem/1.0625rem 'Inter';
                letter-spacing: -0.0063rem;
                color: #646981;
                margin-bottom: 0.1875rem;
              }
            }
            .info {
              a {
                font: normal bold 1.5rem/1.8125rem 'Inter';
                letter-spacing: -0.0107rem;
                color: #363843;
                margin-bottom: 0.375rem;
              }
              p {
                font: normal normal 0.8125rem/1rem 'Inter';
                letter-spacing: -0.0058rem;
                color: #646981;
              }
            }
          }
        }
      }
    }
    .dev {
      display: flex;
      align-items: center;
      ul {
        display: flex;
        align-items: center;
        li {
          &:first-child {
            padding-right: 1.25rem;
            margin-right: 1.125rem;
            border-right: 0.0625rem solid rgba(27, 78, 141, 0.3);
          }
        }
      }
    }
    p {
      max-width: 75rem;
      margin: 0 auto;
      color: #a0a4b3;
      font-size: 0.8125rem;
      line-height: 1.25rem;
    }
  }
  @media (max-width: 75rem) {
    .area-primaria {
      padding: 2.5rem 0rem;
      flex-direction: column;
      .esq {
        .atendimento {
          display: flex;
          flex-wrap: wrap;
          justify-content: space-evenly;
          align-items: center;
          margin: 0 0 3em 0;
          img {
            margin-right: 0.3125rem;
          }
          .info {
            max-width: 18.75rem;
            margin-left: -5em;
            span {
              display: block;
              font-size: 0.875rem;
              line-height: 1.25rem;
              color: #646981;
            }
            a {
              font-weight: bold;
              font-size: 2.0625rem;
              line-height: 2.5rem;
              color: #363843;
            }
          }
        }
        width: 100%;
        margin-bottom: 2.5rem;
      }
    }
    .area-secundaria {
      padding-top: 2rem;

      .cont-geral {
        flex-direction: column;
        align-items: flex-start;
      }
      .esq {
        flex-direction: column;
        align-items: center;
        margin-bottom: 1.5rem;
        .item {
          margin-left: 0;
          margin-bottom: 1.875rem;
          &:last-child {
            margin-bottom: 0rem;
          }
          &:nth-child(2) {
            ul {
              li {
                margin: 0.2em 0em 0.2em 0em;
                &:nth-child(3) {
                  margin-right: 1.5em;
                }
              }
            }

            .selos {
              margin: 0em;
            }
          }

          .formasDePagamento {
            margin: 0;
            span {
              text-align: center;
            }
          }
        }
      }
      .avaliacaoConsumidor {
        align-items: center;
      }
      .dev {
        display: flex;
        align-items: center;
        padding-left: 3em;
        ul {
          display: flex;
          align-items: center;
          li {
            &:first-child {
              padding-right: 1.25rem;
              margin-right: 1.125rem;
            }
          }
        }
      }
    }
    .area-compra {
      .cont-geral {
        margin-bottom: 0;
      }
      .esq {
        flex-direction: column;
        align-items: center;
        .item {
          margin-left: 0rem;
          margin-bottom: 2.5rem;
          display: flex;
          flex-direction: column;
          align-items: center;
          &:last-child {
            margin-bottom: 0rem;
          }
        }
      }
    }
  }
  @media (max-width: 30rem) {
    .area-primaria {
      padding: 0.625rem;
      .esq {
        margin-bottom: 0.625rem;
        .atendimento {
          align-items: center;
          margin: 1em 0 3em 0;
          img {
            margin: 1.2em 0 0 0;
          }
          .info {
            max-width: 13.125rem;
            margin: 1em 1em 0 0;
            align-items: center;
            a {
              font-size: 1.5rem;
              line-height: 2.5rem;
            }
            span {
              font-size: 0.75rem;
            }
          }
        }
      }
      nav {
        flex-wrap: wrap;
        align-items: flex-start;
        .item {
          margin-left: 0;
          width: 50%;
          &:last-child {
            margin: 0;
            h3 {
              display: none;
            }
          }
          h3 {
            font-size: 1.125rem;
            line-height: 1.625rem;
            margin-bottom: 0.75rem;
          }
          ul {
            li {
              a {
                font-size: 0.8125rem;
              }
            }
          }
        }
      }
    }
    .area-secundaria {
      padding-top: 0.9375rem;
      margin-bottom: 2.5rem;

      .esq {
        margin-right: 0;
        margin-bottom: 0.9375rem;
        width: 100%;
        .item {
          width: 100%;
          display: flex;
          flex-direction: column;
          align-items: center;
          margin-bottom: 0.3125rem;

          .selos {
            flex-wrap: wrap;
            justify-content: center !important;
            margin: 1.75rem 0 1.375rem 0 !important;
            li {
              width: 100%;
              display: flex;
              justify-content: center;
            }
          }

          &:nth-child(2) {
            .selos {
              width: 100%;
              justify-content: space-between;
              li {
                margin-left: 0 !important;
                &:nth-child(3) {
                  margin-right: 0em;
                }
              }
            }
          }
        }
      }
      .avaliacaoConsumidor {
        display: flex;
        align-items: center;
      }
      .dev {
        width: 100%;
        justify-content: center;
        padding-left: 3em;
      }
    }
    .area-compra {
      .selos {
        flex-wrap: wrap;
        justify-content: center !important;
        li {
          width: 100%;
          display: flex;
          justify-content: center;
        }
      }
    }
  }
`

type FooterContainerProps = {
  marginBottom?: boolean
}

export const FooterContainer = styled.div<FooterContainerProps>`
  max-width: 81.875rem;
  width: 100%;
  padding: 0rem 0.9375rem;
  margin-left: auto;
  margin-right: auto;

  @media (max-width: 30rem) {
    ${({ marginBottom }) =>
      marginBottom &&
      css`
        margin-bottom: 2.5rem;
      `}
  }
`
